import { render } from "./RisfondHead.vue?vue&type=template&id=de7468b8&scoped=true&ts=true"
import script from "./RisfondHead.vue?vue&type=script&lang=ts"
export * from "./RisfondHead.vue?vue&type=script&lang=ts"

import "./RisfondHead.vue?vue&type=style&index=0&id=de7468b8&scoped=true&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de7468b8"]])

export default __exports__